import { useForm } from '@nerdgeschoss/react-use-form-library';
import React from 'react';
import { useModal } from '../../components/Modal/PresentedModal';
import { t } from '../../locales/translate';
import { graphql } from '../../generated';
import { useMutation } from '@apollo/client';
import { handleError } from '../../model/notification';
import { FormForm } from '../../components/Form/FormForm';
import { Text } from '../../components/text/text';

const UPDATE_EXPORT = graphql(`
  mutation UpdateChart($id: ID!) {
    updateExport(input: { id: $id, error: null }) {
      clientMutationId
      export {
        id
      }
    }
  }
`);

interface Props {
  onUpdate: () => void;
  id: string;
}

export function ConfirmResolvedErrors({ onUpdate, id }: Props): JSX.Element {
  const { open, Modal, close, size } = useModal();
  const [updateExport] = useMutation(UPDATE_EXPORT);

  const { onSubmit, submissionStatus } = useForm({
    model: {},
    onSubmit: async () => {
      await updateExport({ variables: { id } });

      onUpdate();
      close();
    },
    onSubmitError: handleError,
  });

  return (
    <Modal open={open} size={size} title={t.model.charts.confirmResolvedTitle}>
      <FormForm
        onSubmit={onSubmit}
        onClose={close}
        canSubmit
        loading={submissionStatus === 'submitting'}
        saveButtonTitle={t.model.charts.confirm}
      >
        <Text type="card-text">{t.model.charts.confirmResolved}</Text>
      </FormForm>
    </Modal>
  );
}
